export default __webpack_public_path__ + "static/media/bloco_image_2.144f04a8.svg";